/* tslint:disable */
/* eslint-disable */

/**
 * 1 = Belge
 * 2 = Etranger
 */
export enum TypePersonnePhysiqueValues {
  Belge = 1,
  Etranger = 2
}
